"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _docFlux = require("@harvest-profit/doc-flux");

var _HeaderFooter = require("./HeaderFooter");

var _Utilities = require("./Utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Renders text.
 */
var TextNode = /*#__PURE__*/function (_DOMComponent) {
  _inherits(TextNode, _DOMComponent);

  var _super = _createSuper(TextNode);

  function TextNode() {
    _classCallCheck(this, TextNode);

    return _super.apply(this, arguments);
  }

  _createClass(TextNode, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: "transform",
    value: function transform(DOM) {
      var _objectSpread2;

      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var stack = [];
      var options = {};

      for (var i = 0; i < DOM.value.length; i += 1) {
        var child = DOM.value[i];

        if (typeof child === 'number') {
          stack.push(child.toString());
        } else if (typeof child === 'string') {
          stack.push((0, _Utilities.parseText)(child, variables));
        } else if (child.ref) {
          if (child.ref instanceof _HeaderFooter.Header) {
            options = _objectSpread(_objectSpread({}, options), {}, {
              header: child.ref.constructor.transform(child, variables)
            });
          }

          if (child.ref instanceof _HeaderFooter.Footer) {
            options = _objectSpread(_objectSpread({}, options), {}, {
              footer: child.ref.constructor.transform(child, variables)
            });
          }

          stack.push(child.ref.constructor.transform(child, variables));
        }
      }

      var classNames = (0, _Utilities.getClassNames)(DOM);
      var stackName = 'text';

      if (DOM.props.row) {
        stackName = 'columns';
      } else if (DOM.elementName === 'div') {
        stackName = 'stack';
      } else if (DOM.elementName === 'ul') {
        stackName = 'ul';
      } else if (DOM.elementName === 'ol') {
        stackName = 'ol';
      }

      if (stackName === 'text' && DOM.value.length === 1) {
        var _stack = stack;

        var _stack2 = _slicedToArray(_stack, 1);

        stack = _stack2[0];
      }

      var style = _objectSpread(_objectSpread({}, DOM.props.style || {}), (0, _Utilities.pick)(DOM.props, ['colSpan']));

      var value = _objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, stackName, stack), _defineProperty(_objectSpread2, "style", ["_".concat(DOM.elementName), DOM.elementName].concat(_toConsumableArray(classNames))), _objectSpread2), style), options);

      if (DOM.elementName === 'a' && DOM.props.href) {
        if (DOM.props.internal) {
          return _objectSpread(_objectSpread({}, value), {}, {
            linkToPage: DOM.props.href
          });
        }

        return _objectSpread(_objectSpread({}, value), {}, {
          link: DOM.props.href
        });
      }

      return value;
    }
  }]);

  return TextNode;
}(_docFlux.DOMComponent);

exports["default"] = TextNode;

_defineProperty(TextNode, "propTypes", {
  children: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/DOMComponents/TextNode.js
// module id = 49
// module chunks = 0